import { getHotspotPopupContent } from "./hotspotPopupContent";
import {
  hasSeenDeskPopup, markDeskPopupSeen,
  hasSeenBookshelfPopup, markBookshelfPopupSeen,
  hasSeenHotspotPopup, markHotspotPopupSeen,
} from "./hotspotPopupStorage";

export function planHotspotOpen(hotspotId, { userId, hasActiveHotspot = false } = {}) {
  const content = getHotspotPopupContent(hotspotId);
  if (!content) return { known: false };

  if (hotspotId === "desk" && hasSeenDeskPopup(userId)) {
    return { known: true, openDesk: true };
  }

  const onceOnly = !!content.firstTimeOnly;
  const seen = onceOnly && hasSeenHotspotPopup(hotspotId, userId);
  if (content.opensPanelOnClose && seen) {
    return { known: true, openPanel: hotspotId };
  }

  if (hotspotId === "bookshelf" && hasSeenBookshelfPopup(userId)) {
    return { known: true, openPanel: "bookshelf", clearActiveHotspot: hasActiveHotspot };
  }

  if (onceOnly) markHotspotPopupSeen(hotspotId, userId);
  return { known: true, showPopup: hotspotId, clearActiveHotspot: hasActiveHotspot };
}

export function planHotspotClose(hotspotId, userId) {
  if (!hotspotId) return {};

  if (hotspotId === "desk") {
    if (!hasSeenDeskPopup(userId)) markDeskPopupSeen(userId);
    return { openDesk: true };
  }

  if (hotspotId === "bookshelf") {
    if (!hasSeenBookshelfPopup(userId)) markBookshelfPopupSeen(userId);
    return { openPanel: "bookshelf" };
  }

  const content = getHotspotPopupContent(hotspotId);
  if (content?.opensPanelOnClose) {
    if (content.firstTimeOnly) markHotspotPopupSeen(hotspotId, userId);
    return { openPanel: hotspotId };
  }

  return {};
}
